define('SageDotCom/DataLayer/Global/tabsets',['jquery',
        'SageDotCom/DataLayer/tealium',
        'SageDotCom/DataLayer/Events/bodySelect'],
    function ($, tealium, bodySelect) {
        function globalTabsetTracking() { }

        globalTabsetTracking.prototype.initialize = function initialize() {
            $(".score-tab-panel:not([data-xpr-state], [data-tracking]), .score-accordion-panel").each(function (key, panel) {
                var id = $(panel).attr('id');
                $('.nav-tab-btn[href^="#' + id + '"], a[href^="#' + id + '"]').click(function (event) {
                    // button has a aria-expanded attribute set to either 'true' or 'false
                    // check it's value before raising the event to prevent it from being
                    // raised needlessly once the panel is already opened.  for whatever
                    // reason, this attribute is undefined if the panel hasn't been activated
                    var expanded = $(event.currentTarget).attr('aria-expanded');
                    var selected = $(event.currentTarget).attr('aria-selected');
                    //If undefined, assume false
                    var isExpanded = typeof expanded == 'undefined' ? "false" : expanded;
                    var isSelected = typeof selected == 'undefined' ? "false" : selected;
                    if (isExpanded === "false" && isSelected === "false") {
                        var data = bodySelect.GenerateEventMetadata(panel, undefined, undefined, undefined, undefined, undefined, this.tagName.toLowerCase());
                        tealium.event(data);
                    }
                });
                $(panel).attr('data-tracking', bodySelect.getName());
            });
            
            $(".tabAccordion-accordion .tabAccordion-panel-accordion .panel-heading .nav-tab-btn, .tabAccordion-accordion .tabAccordion-panel-accordion .panel-heading a").each(function (key, panel) {
                var id = $(panel).attr('href');
                $('.nav-tab-btn[href^="' + id + '"], a[href^="' + id + '"]').click(function (event) {
                    // button has a aria-expanded attribute set to either 'true' or 'false
                    // check it's value before raising the event to prevent it from being
                    // raised needlessly once the panel is already opened.  for whatever
                    // reason, this attribute is undefined if the panel hasn't been activated
                    var expanded = $(event.currentTarget).attr('aria-expanded');
                    if (typeof expanded == 'undefined' || expanded === 'false') {
                        var data = bodySelect.GenerateEventMetadata(panel, undefined, undefined, undefined, undefined, undefined, this.tagName.toLowerCase());
                        tealium.event(data);
                    }
                });
                $(panel).attr('data-tracking', bodySelect.getName());
            });

        }

        return new globalTabsetTracking();
    });
